import Vue from 'vue'
import App from './App.vue'
// 引入Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
